import {
  withTranslation,
} from 'react-i18next';

import RatingFieldsView from './RatingFieldsView';

const TranslatedComponent = withTranslation()(RatingFieldsView);

const Component = TranslatedComponent;

export default Component;
